import React, { useEffect, useState } from 'react';
import { Button } from 'src/components/new/Button';
import { Typography } from 'src/components/new/Typography';
import { CurrentUser } from 'src/utils/constant';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'src/store/store';
import { addOrganizationPromoCode, getOrganizationPrintCredits } from 'src/features/company/utils';
import AddOrganizationPromoCode from './modals/AddOrganizationPromoCode';
import PAFSection from './PAFSection';
import BkSnackBar from 'src/components/snackbar/BkSnackBar';
import { PaymentMethodsSection } from './PaymentMethodsSection';
import { OrganizationType } from 'src/utils/enums/organization-type.enum';

interface BillingTabProps {
  currentUser: CurrentUser;
}

interface SnackbarProps {
  type: 'success' | 'error';
  msg: string;
}

const BillingTab: React.FC<BillingTabProps> = ({ currentUser }) => {
  const [showPromoCodeDialog, setShowPromoCodeDialog] = useState(false);
  const [promoCodeNetworkError, setPromoCodeNetworkError] = useState('');
  const [showSnackbarMsg, setShowSnackbarMsg] = useState<SnackbarProps>({
    msg: '',
    type: 'success',
  });

  const dispatch: AppDispatch = useDispatch();
  useEffect(() => {
    dispatch(getOrganizationPrintCredits());
  }, []);

  const printCredits = useSelector((state: RootState) => state.company.printCredits);

  const addPromoCode = (name: string) => {
    dispatch(addOrganizationPromoCode(name)).then((result) => {
      if (addOrganizationPromoCode.fulfilled.match(result)) {
        setShowSnackbarMsg({ msg: 'Promo code added', type: 'success' });
        setShowPromoCodeDialog(false);
        dispatch(getOrganizationPrintCredits());
      }
      if (addOrganizationPromoCode.rejected.match(result)) {
        if (result.payload === 'Promo code already used by member of organization') {
          setPromoCodeNetworkError('Promo code already used by member of organization');
        } else {
          setPromoCodeNetworkError('This promo code is invalid');
        }
      }
    });
  };

  const onOpenAddPromoCode = () => {
    setShowPromoCodeDialog(true);
    setPromoCodeNetworkError('');
  };

  return (
    <>
      {currentUser.organization.type !== OrganizationType.CHAPTER_13_TRUSTEE && (
        <PaymentMethodsSection setShowSnackbarMsg={setShowSnackbarMsg} />
      )}
      <div style={{ padding: '1.25rem' }}>
        <BkSnackBar
          open={!!showSnackbarMsg.msg}
          handleCloseSnackbar={() => setShowSnackbarMsg({ type: 'success', msg: '' })}
          snackMessage={showSnackbarMsg.msg}
          severity={showSnackbarMsg.type}
        />
        <Typography fontWeight={400} fontSize={32} sx={{ lineHeight: '2.5rem', color: '#1D1B20', marginBottom: '1.5rem' }}>
          Print Credit Balance
        </Typography>
        <Typography fontSize={14}>Outstanding Print Credits</Typography>
        <Typography fontSize={20} fontWeight={500}>
          ${(printCredits || 0).toFixed(2)}
        </Typography>
        <Button type="outline" onClick={onOpenAddPromoCode} sx={{ width: '31.25rem', mt: 2 }}>
          Add Promo Code
        </Button>
        <AddOrganizationPromoCode
          open={showPromoCodeDialog}
          onClose={() => setShowPromoCodeDialog(false)}
          onSuccess={addPromoCode}
          networkError={promoCodeNetworkError}
        />
        <PAFSection />
      </div>
    </>
  );
};

export default BillingTab;
